import { LocalizedText } from "../../types/localizedText"
import { TFunction } from "i18next"

export const handleLocalizedTextTranslation = (title: LocalizedText, t: TFunction) =>
    title.NeedLocalization ? t(title.Value) : title.Value
